module.exports = __webpack_public_path__ + "static/media/occommodation-flower.756d29be.svg";